var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95353 0C9.2925 0 9.60208 0.192443 9.7521 0.496414L11.9004 4.84933L16.7041 5.54735C17.0396 5.5961 17.3183 5.83106 17.423 6.15344C17.5278 6.47583 17.4404 6.82972 17.1977 7.06633L13.7217 10.4546L14.5422 15.2389C14.5995 15.573 14.4622 15.9107 14.188 16.1099C13.9137 16.3092 13.5501 16.3354 13.2501 16.1777L8.95353 13.9189L4.65694 16.1777C4.3569 16.3354 3.99333 16.3092 3.7191 16.1099C3.44486 15.9107 3.30752 15.573 3.36482 15.2389L4.1854 10.4546L0.709387 7.06633C0.466651 6.82972 0.379292 6.47583 0.484041 6.15344C0.588791 5.83106 0.867481 5.5961 1.20293 5.54735L6.00666 4.84933L8.15495 0.496414C8.30497 0.192443 8.61455 0 8.95353 0ZM8.95353 2.90274L7.39661 6.05741C7.26689 6.32024 7.01615 6.50242 6.72609 6.54457L3.24471 7.05044L5.76386 9.506C5.97375 9.71059 6.06952 10.0054 6.01998 10.2942L5.42529 13.7616L8.53912 12.1245C8.79856 11.9881 9.1085 11.9881 9.36793 12.1245L12.4818 13.7616L11.8871 10.2942C11.8375 10.0054 11.9333 9.71059 12.1432 9.506L14.6623 7.05044L11.181 6.54457C10.8909 6.50242 10.6402 6.32024 10.5104 6.05741L8.95353 2.90274Z",
    fill: "#266071"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconBlue);
export default __webpack_public_path__ + "static/media/star_icon_blue.efe7a1b11c54baee0dc1d2c550d94945.svg";
export { ForwardRef as ReactComponent };